// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"333":"epub","962":"home"}[chunkId] || chunkId) + "." + {"333":"36ef075f","869":"d2a9e61a","962":"3a56003a"}[chunkId] + ".chunk.js";
};